module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[10]375.a10e178.woff2";